import { COUNTRY_ACTIONS, CURRENCY_ACTIONS, SECTOR_ACTIONS, REGION_ACTIONS, MATURITY_YEAR_ACTIONS, INDUSTRY_ACTIONS, ISSUE_TYPE_ACTIONS, GET_TRENDING_BONDS_ACTIONS, SEND_FEEDBACK_ACTIONS, SUPPORT_FORM_ACTIONS, DATA_UPLOAD_STATUS_ACTIONS, GET_ADSKEY_EXISTS_ACTIONS, CREATE_ADSKEY_EXISTS_ACTIONS } from "../../actionType/common";

const intialState = {
    countryData: [],
    isCountryLoader: false,
    currencyData: [],
    isCurrencyLoader: false,
    sectorData: [],
    isSectorLoader: false,
    issueTypeData: [],
    isIssueTypeLoader: false,
    industryData: [],
    isIndustryLoader: false,
    regionData: [],
    isRegionLoader: false,
    maturityData: [],
    isMaturityLoader: false,
    trendingBondsData: [],
    isTrendingBondsLoader: false,
    sendFeedbackData: {},
    issendFeedbackDataLoader: false,
    supportFormData: {},
    isSupportFormDataLoader: false,
    dataUploadStatusData: {},
    isDataUploadStatusLoader: false,
    getadsKeyExistsData: {},
    isGetadsKeyExistsDataLoader: false,
    createAdsKeyExistsData: {},
    isCreateAdsKeyExistsDataLoader: false
};

export const commonReducer = (state = intialState, { type, payload }: any) => {
    switch (type) {
        // COUNTRY DATA
        case COUNTRY_ACTIONS.COUNTRY_BONDS_REQUEST:
            return { ...state, countryData: payload, isCountryLoader: false };
        case COUNTRY_ACTIONS.COUNTRY_BONDS:
            return { ...state, countryData: payload, isCountryLoader: true };

        case COUNTRY_ACTIONS.COUNTRY_BONDS_ERROR:

            return { ...state, countryData: payload, isCountryLoader: false };

        // CURRENCY DATA
        case CURRENCY_ACTIONS.CURRENCY_BONDS:
            return { ...state, currencyData: payload, isCurrencyLoader: false };
        case CURRENCY_ACTIONS.CURRENCY_BONDS_REQUEST:
            return { ...state, currencyData: payload, isCurrencyLoader: true };

        case CURRENCY_ACTIONS.CURRENCY_BONDS_ERROR:

            return { ...state, currencyData: payload, isCurrencyLoader: false };
        // SECTOR DATA
        case SECTOR_ACTIONS.SECTOR_BONDS:
            return { ...state, sectorData: payload, isSectorLoader: false };
        case SECTOR_ACTIONS.SECTOR_BONDS_REQUEST:
            return { ...state, sectorData: payload, isSectorLoader: true };

        case SECTOR_ACTIONS.SECTOR_BONDS_ERROR:

        // ISSUE TYPE DATA
        case ISSUE_TYPE_ACTIONS.ISSUE_TYPE_BONDS:
            return { ...state, issueTypeData: payload, isIssueTypeLoader: false };
        case ISSUE_TYPE_ACTIONS.ISSUE_TYPE_BONDS_REQUEST:
            return { ...state, issueTypeData: payload, isIssueTypeLoader: true };

        case ISSUE_TYPE_ACTIONS.ISSUE_TYPE_BONDS_ERROR:

        // INDUSTRY DATA
        case INDUSTRY_ACTIONS.INDUSTRY_BONDS:
            return { ...state, industryData: payload, isIndustryLoader: false };
        case INDUSTRY_ACTIONS.INDUSTRY_BONDS_REQUEST:
            return { ...state, industryData: payload, isIndustryLoader: true };

        case INDUSTRY_ACTIONS.INDUSTRY_BONDS_ERROR:

            return { ...state, industryData: payload, isIndustryLoader: false };
        // REGION DATA
        case REGION_ACTIONS.REGION_BONDS:
            return { ...state, regionData: payload, isRegionLoader: false };
        case REGION_ACTIONS.REGION_BONDS_REQUEST:
            return { ...state, regionData: payload, isRegionLoader: true };

        case REGION_ACTIONS.REGION_BONDS_ERROR:

            return { ...state, regionData: payload, isRegionLoader: false };
        // MATURITY YEAR DATA
        case MATURITY_YEAR_ACTIONS.MATURITY_YEAR_BONDS:
            return { ...state, maturityData: payload, isMaturityLoader: false };
        case MATURITY_YEAR_ACTIONS.MATURITY_YEAR_BONDS_REQUEST:
            return { ...state, maturityData: payload, isMaturityLoader: true };

        case MATURITY_YEAR_ACTIONS.MATURITY_YEAR_BONDS_ERROR:

            return { ...state, maturityData: payload, isMaturityLoader: false };

        // GET TRENDING BONDS
        case GET_TRENDING_BONDS_ACTIONS.GET_TRENDING_BONDS:
            return { ...state, trendingBondsData: payload, isTrendingBondsLoader: false };
        case GET_TRENDING_BONDS_ACTIONS.GET_TRENDING_BONDS_REQUEST:
            return { ...state, trendingBondsData: payload, isTrendingBondsLoader: true };

        case GET_TRENDING_BONDS_ACTIONS.GET_TRENDING_BONDS_ERROR:

            return { ...state, trendingBondsData: payload, isTrendingBondsLoader: false };
        // GET TRENDING BONDS
        case SEND_FEEDBACK_ACTIONS.SEND_FEEDBACK_REQUEST:
            return { ...state, sendFeedbackData: payload, issendFeedbackDataLoader: false };
        case SEND_FEEDBACK_ACTIONS.SEND_FEEDBACK_RESPONSE:
            return { ...state, sendFeedbackData: payload, issendFeedbackDataLoader: true };

        case SEND_FEEDBACK_ACTIONS.SEND_FEEDBACK_ERROR:

            return { ...state, sendFeedbackData: payload, issendFeedbackDataLoader: false };

        // GET TRENDING BONDS
        case SUPPORT_FORM_ACTIONS.SUPPORT_FORM_REQUEST:
            return { ...state, supportFormData: payload, isSupportFormDataLoader: false };
        case SUPPORT_FORM_ACTIONS.SUPPORT_FORM_RESPONSE:
            return { ...state, supportFormData: payload, isSupportFormDataLoader: true };
        case SUPPORT_FORM_ACTIONS.SUPPORT_FORM_ERROR:
            return { ...state, supportFormData: payload, isSupportFormDataLoader: false };

        // GET TRENDING BONDS
        case DATA_UPLOAD_STATUS_ACTIONS.DATA_UPLOAD_STATUS_REQUEST:
            return { ...state, dataUploadStatusData: payload, isDataUploadStatusLoader: false };
        case DATA_UPLOAD_STATUS_ACTIONS.DATA_UPLOAD_STATUS_RESPONSE:
            return { ...state, dataUploadStatusData: payload, isDataUploadStatusLoader: true };
        case DATA_UPLOAD_STATUS_ACTIONS.DATA_UPLOAD_STATUS_ERROR:
            return { ...state, dataUploadStatusData: payload, isDataUploadStatusLoader: false };

        //GET ADS KEY EXISTS ACTION
        case GET_ADSKEY_EXISTS_ACTIONS.GET_ADSKEY_EXISTS_REQUEST:
            return { ...state, getadsKeyExistsData: payload, isGetadsKeyExistsDataLoader: false };
        case GET_ADSKEY_EXISTS_ACTIONS.GET_ADSKEY_EXISTS_RESPONSE:
            return { ...state, getadsKeyExistsData: payload, isGetadsKeyExistsDataLoader: true };

        case GET_ADSKEY_EXISTS_ACTIONS.GET_ADSKEY_EXISTS_ERROR:

            return { ...state, getadsKeyExistsData: payload, isGetadsKeyExistsDataLoader: false };

        //CREATE ADS KEY EXISTS ACTION
        case CREATE_ADSKEY_EXISTS_ACTIONS.CREATE_EXISTS_REQUEST:
            return { ...state, createAdsKeyExistsData: payload, isCreateAdsKeyExistsDataLoader: false };
        case CREATE_ADSKEY_EXISTS_ACTIONS.CREATE_EXISTS_RESPONSE:
            return { ...state, createAdsKeyExistsData: payload, isCreateAdsKeyExistsDataLoader: true };

        case CREATE_ADSKEY_EXISTS_ACTIONS.CREATE_EXISTS_ERROR:

            return { ...state, createAdsKeyExistsData: payload, isCreateAdsKeyExistsDataLoader: false };

        //default
        default:
            return state;
    }
};
